import React from 'react';
import FileInput from './FileInput';
import { connect } from 'react-redux';
import { getColorsNoInSVG, setSVGColor } from '../util';

import {
  setShoppingIconElementFileInfo,
  setShoppingIconElementIconSize,
  setShoppingIconElementIconColor,
  setShoppingIconElementTextColor,
} from '../actions/shopping-icon-element-actions';

import styles from '../../../../stylesheet/css/header-builder/shopping-icon-element-options.css';

function decode(iconDataURL) {
  if (!iconDataURL) {
    return '';
  }

  const searchPattern = 'base64,';
  const startIndex = iconDataURL.indexOf(searchPattern) + searchPattern.length;

  return atob(iconDataURL.substr(startIndex));
}

function encode(svgTextContent) {
  if (!svgTextContent) {
    return '';
  }

  return `data:image/svg+xml;base64,${btoa(svgTextContent)}`;
}

function renderSVGWarning(svgContentDataURL) {
  if (svgContentDataURL === undefined) {
    return;
  }

  try {
    const svgContent = decode(svgContentDataURL);
    const dectectedColorsNo = getColorsNoInSVG(svgContent);

    if (dectectedColorsNo > 1) {
      return (
        <p className={styles.warning}>
          {dectectedColorsNo} colors detected in this icon file, so may has not a good appearance when converting all these colors to a single color.
        </p>
      );
    }
  } catch(ex) {
    console.error(ex);
  }
}

export const ShoppingIconElementOptions = ({
  onFileInfoChange,
  onIconSizeChange,
  onIconColorChange,
  onTextColorChange,
  options = {},
}) => {
  const { fileInfo = {}, iconSize, iconColor, textColor } = options;
  const decodedIconContent = decode(fileInfo.content);

  const handleIconSizeChange = e => onIconSizeChange(e.target.value);
  const handleIconColorChange = e => onIconColorChange(e.target.value, decodedIconContent);
  const handleTextColorChange = e => onTextColorChange(e.target.value);

  const onFileClick = fileInfo => {
  };

  return (
    <div>
      <header>Icon file (Monocolored SVG):</header>
      <FileInput
        fileInfo={fileInfo}
        format="dataURL"
        accept="image/svg+xml"
        onChange={onFileInfoChange}
        onFileClick={onFileClick}
      />
      {renderSVGWarning(fileInfo.originalContent)}

      <header>Icon Size:</header>
      <select value={iconSize} onChange={handleIconSizeChange}>
        <option value="16px">16</option>
        <option value="32px">32</option>
        <option value="48px">48</option>
        <option value="64px">64</option>
      </select>

      <header>Icon Color:</header>
      <input type="color" value={iconColor} onChange={handleIconColorChange} />
      <input type="text" value={iconColor} className={styles.colorText} onChange={handleIconColorChange} />

      <header>Text Color:</header>
      <input type="color" value={textColor} onChange={handleTextColorChange} />
      <input type="text" value={textColor} className={styles.colorText} onChange={handleTextColorChange} />

      <header>Preview:</header>
      <div className={styles.preview}>
        {
          fileInfo.content
            ? <img
                src={`data:image/svg+xml;charset=UTF-8,${setSVGColor(decodedIconContent, iconColor)}`}
                style={{
                  width: iconSize,
                  height: iconSize,
                }}
              />
            : <div>No icon choosed.</div>
        }
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id, options = {} } = ownProps;
  const { iconColor } = options;

  return {
    onFileInfoChange(value) {
      const coloredContent = encode(setSVGColor(decode(value.content), iconColor));
      dispatch(setShoppingIconElementFileInfo({ device, id, value, coloredContent }));
    },

    onIconSizeChange(value) {
      dispatch(setShoppingIconElementIconSize({ device, id, value }));
    },

    onIconColorChange(value, decodedIconContent) {
      const coloredContent = encode(setSVGColor(decodedIconContent, value));
      dispatch(setShoppingIconElementIconColor({ device, id, value, coloredContent }));
    },

    onTextColorChange(value) {
      dispatch(setShoppingIconElementTextColor({ device, id, value }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ShoppingIconElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/ShoppingIconElementOptions.js